import { RootState } from '../root.reducers';
import { FilterGroup } from './filterGroup.types';

export const getFilterGroupList = (state: RootState): FilterGroup[] =>
  state.filterGroup.entities;

export const getFilterGroup = (state: RootState): FilterGroup | null =>
  state.filterGroup.single;

export const getSelectedFilterGroup = (state: RootState): FilterGroup[] =>
  state.filterGroup.selected;

export const getFilterGroupCreatedId = (state: RootState): string | null =>
  state.filterGroup.createdId;

export const isFilterGroupCreatePopupOpen = (state: RootState): boolean =>
  state.filterGroup.ui.isCreatePopupOpen;

export const isFilterGroupLoading = (state: RootState): boolean =>
  state.filterGroup.ui.isLoading;
